module.exports = __webpack_public_path__ + "static/media/32import-65.eb68646e.xlsx";